<template>
  <div class="container">
    <div class="overflow-auto">
      <div v-if="lists.length > 0">
        <table class="table table-hover ui-table">
          <thead>
            <tr>
              <th>{{ $t('invoice.plateNo') }}</th>
              <th>{{ $t('invoice.zone') }}</th>
              <th style="width: 24%;">{{ $t('invoice.driver') }}</th>
              <th class="text-center">{{ $t('invoice.availableSeat') }}</th>
              <th style="width: 10%;" class="ts-whitespace-no-wrap">
                {{ $t('invoice.register') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(list, index) in lists" :key="index">
              <td>{{ list.plate_no }}</td>
              <td>
                <span v-for="(op, index) in list.operations" :key="index">
                  {{ op.vehicle_zone.zone_name_en }},
                </span>
              </td>
              <td>
                <span v-for="(op, index) in list.operations" :key="index">
                  {{ op.driver.name_en }},
                </span>
              </td>
              <td class="text-center">
                {{ list.max_student - parseInt(list.register_count) }}
              </td>
              <td class="text-center">
                <a
                  href="#"
                  class="text-red"
                  v-if="list.max_student - parseInt(list.register_count) == 0"
                  ><i class="fas fa-user-lock"></i
                ></a>
                <a
                  href="#"
                  v-else
                  :class="{
                    'text-primary': selectedVehicle == list.vehicle_id
                  }"
                  @click.prevent="register(list.vehicle_id)"
                >
                  <i class="fas fa-bus"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="text-center">
        <ts-button :waiting="loading" @click="$emit('reload')">{{
          $t('invoice.reload')
        }}</ts-button>
        <p>
          <small
            ><i>{{ $t('invoice.note') }}: </i>
            {{
              $t(
                'invoiceIfnoseeanythingrecordsherePlzgotosetupvehicleoperation'
              )
            }}</small
          >
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'vehicleOperationList',
  props: ['lists', 'loading'],
  data() {
    return {
      selectedVehicle: null
    }
  },
  methods: {
    register(vehicleId) {
      this.selectedVehicle = vehicleId
      this.$emit('vehicle', vehicleId)
    }
  }
}
</script>

<style lang="css" scoped>
.table > thead > tr > th {
  padding: 5px 15px;
}
.table > tbody > tr > td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border: none !important;
  font-size: 12px !important;
}
.container {
  max-height: 35vh;
  height: 30vh;
}
</style>
